import {React} from 'react';
import {Button} from 'reactstrap';
import './style.scss';

const FormButton = ({type, onClick, disabled, className, value, color = 'primary', ...rest}) => {
    return (
        <Button color={color} type={type ? type : "submit"} onClick={onClick}
                disabled={disabled} className={'form-button ' + className} {...rest}>{value}</Button>
    )
}

export default FormButton;